var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M29.393 23.36c-.874-.733-6-3.979-6.852-3.83-.4.071-.706.412-1.525 1.389a11.687 11.687 0 01-1.244 1.347 10.757 10.757 0 01-2.374-.88 14.7 14.7 0 01-6.784-6.786 10.757 10.757 0 01-.88-2.374 11.687 11.687 0 011.347-1.244c.976-.819 1.318-1.123 1.389-1.525.149-.854-3.1-5.978-3.83-6.852C8.334 2.243 8.056 2 7.7 2 6.668 2 2 7.772 2 8.52c0 .061.1 6.07 7.689 13.791C17.41 29.9 23.419 30 23.48 30c.748 0 6.52-4.668 6.52-5.7 0-.356-.243-.634-.607-.94zM23 15h2a8.009 8.009 0 00-8-8v2a6.006 6.006 0 016 6z","data-original":"#000000","key":0}),React.createElement("path",{"d":"M28 15h2A13.015 13.015 0 0017 2v2a11.013 11.013 0 0111 11z","data-original":"#000000","key":1})]);
}

Phone.defaultProps = {"width":"512","height":"512","viewBox":"0 0 32 32"};

module.exports = Phone;

Phone.default = Phone;
